/**
 * @copyright: 2020 NTWIST
 * @Author: NTWIST
 * @Date: 2021-03-15 11:07:50
 * @Last Modified by: Pradeep Chandra
 * @Last Modified time: 2022-06-21 19:36:22
 */

import axios from "axios";
import { toaster, Message } from "rsuite";
import React from "react";
import BaseURL from "../api-common";

export async function getLatestNPredictionTraces(
    endUserSession,
    clientPathName
) {
    try {
        let url =
            BaseURL.getBaseURL() +
            clientPathName +
            "/predictionModel/getLatestNPredictionTraces";

        let res = await axios({
            method: "get",
            url: url,
            withCredentials: true,
            data: {}
        });

        if (res.data.msg === "UNAUTHORIZED") {
            endUserSession();
            return;
        } else if (res.data.statusId === "ERROR") {
            throw "The server has encountered an error.";
        } else if (!res.data.isValidData) {
            throw "The request is invalid.";
        }

        return res.data.traces;
    } catch (e) {
        toaster.push(
            <Message type="error" showIcon closable duration={10000}>
                {
                    <text>
                        Could not get predictions.
                        <br />
                        Error: {e.toString()}
                    </text>
                }
            </Message>
        );
        return null;
    }
}

export async function getPredictionTracesInDateRange(
    endUserSession,
    clientPathName,
    data
) {
    try {
        let url =
            BaseURL.getBaseURL() +
            clientPathName +
            "/predictionModel/getPredictionTracesInDateRange";

        let res = await axios({
            method: "post",
            url: url,
            withCredentials: true,
            data: data
        });

        if (res.data.msg === "UNAUTHORIZED") {
            endUserSession();
            return;
        } else if (res.data.statusId === "ERROR") {
            throw "The server has encountered an error.";
        } else if (!res.data.isValidData) {
            throw "The request is invalid.";
        }

        return res.data.traces;
    } catch (e) {
        toaster.push(
            <Message type="error" showIcon closable duration={10000}>
                {
                    <text>
                        Could not get predictions.
                        <br />
                        Error: {e.toString()}
                    </text>
                }
            </Message>
        );
        return null;
    }
}
